export default __webpack_public_path__ + "static/media/bg.2945536f.svg";